export const container = "cju9vyf";
export const caret = "ctnvu0u";
export const questionStyling = "q1i0e1r2";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");